import React from 'react';
import { Loader2 } from 'lucide-react';
import { useWebSocket } from './context/WebSocketContext';

export default function ProgressBar() {
  const { progress, ocrStatus } = useWebSocket();

  if (ocrStatus && (ocrStatus.status === 'started' || ocrStatus.status === 'progress')) {
    const pct = ocrStatus.percent || 0;
    return (
      <div className="mt-2">
        <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
          <span className="flex items-center gap-1">
            <span className="text-lg">&#x1F4F8;</span>
            <span className="text-amber-600 font-medium">Оцифровка сканов</span>
          </span>
          <span className="text-amber-600">
            {ocrStatus.current && ocrStatus.total
              ? `${ocrStatus.current} / ${ocrStatus.total} стр.`
              : 'Подготовка...'}
          </span>
        </div>
        <div className="w-full bg-amber-100 rounded-full h-2 overflow-hidden">
          <div
            className={`h-full bg-gradient-to-r from-amber-400 to-orange-500 transition-all duration-300 ease-out ${pct === 0 ? 'animate-pulse' : ''}`}
            style={{ width: pct > 0 ? `${pct}%` : '30%' }}
          />
        </div>
        {pct > 0 && <div className="text-xs text-amber-500 mt-1">{pct}%</div>}
      </div>
    );
  }

  if (ocrStatus && ocrStatus.status === 'completed') {
    return (
      <div className="mt-2">
        <div className="flex items-center justify-center gap-2 text-xs text-green-600 mb-1">
          <span className="font-medium">{ocrStatus.message}</span>
        </div>
        <div className="w-full bg-green-100 rounded-full h-2 overflow-hidden">
          <div className="h-full bg-gradient-to-r from-green-400 to-emerald-500 w-full" />
        </div>
      </div>
    );
  }

  if (progress.total === 0) {
    return (
      <div className="mt-2">
        <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
          <span className="flex items-center gap-1">
            <Loader2 className="w-3 h-3 animate-spin" />
            Gemini
          </span>
          <span>Ожидание...</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <div className="h-full bg-gradient-to-r from-purple-500 to-indigo-500 animate-pulse" style={{ width: '30%' }} />
        </div>
      </div>
    );
  }

  const percentage = Math.round((progress.current / progress.total) * 100);

  return (
    <div className="mt-2">
      <div className="flex items-center justify-between text-xs text-gray-500 mb-1">
        <span className="flex items-center gap-1">
          <Loader2 className="w-3 h-3 animate-spin" />
          Gemini
        </span>
        <span>{progress.current} / {progress.total} чанков</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-purple-500 to-indigo-500 transition-all duration-300 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="text-xs text-gray-400 mt-1">{percentage}%</div>
    </div>
  );
}
